import gql from 'graphql-tag'
import Fragment from './fragment'

export const mutation = gql`
  ${Fragment}
  mutation insertAppraisalResponseType($fields: purchase_appraisal_response_type_insert_input!) {
    record: insert_purchase_appraisal_response_type_one(object: $fields) {
      ...AppraisalResponseTypeForm
    }
  }
`

export default mutation
